/*
    Array of the current indications Note: Franchise is not included in the list.
*/

export const indications = ["atopicdermatitis", "asthma", "crswnp", "eoe", "prurigo-nodularis", "csu", "copd", "bp", "afrs"];
